var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-button',{attrs:{"file-key":_vm.fileKey,"size":"mini","type":"primary"},on:{"click":_vm.downLoadFile}},[_vm._v("下载")])}
var staticRenderFns = []

export { render, staticRenderFns }